// extracted by mini-css-extract-plugin
export default {"title":"SecondaryText_title__2ZiHd","text":"SecondaryText_text__a2VOk","sliderButtonContainer":"SecondaryText_sliderButtonContainer__vG3GZ"};